// src/hooks/useHoverRaycast.js
import { useEffect, useRef } from "react";
import { useFrame, useThree } from "@react-three/fiber";
import * as THREE from "three";

export default function useHoverRaycast() {
  const { camera, scene } = useThree();
  const raycaster = useRef(new THREE.Raycaster());
  const mouse = useRef(new THREE.Vector2());
  const hoveredRef = useRef(null);

  useEffect(() => {
    const handlePointerMove = (event) => {
      const { innerWidth, innerHeight } = window;
      mouse.current.x = (event.clientX / innerWidth) * 2 - 1;
      mouse.current.y = -(event.clientY / innerHeight) * 2 + 1;
    };

    window.addEventListener("pointermove", handlePointerMove);
    return () => window.removeEventListener("pointermove", handlePointerMove);
  }, []);

  useFrame(() => {
    if (!scene || !camera) return;

    raycaster.current.setFromCamera(mouse.current, camera);
    const intersects = raycaster.current.intersectObjects(scene.children, true);

    const hit = intersects.find((i) => i.object.userData?.isClickable);

    if (hit && hit.object !== hoveredRef.current) {
      // leave old
      if (hoveredRef.current?.userData?.onPointerOut) {
        hoveredRef.current.userData.onPointerOut();
      }

      // enter new
      hoveredRef.current = hit.object;
      if (hoveredRef.current?.userData?.onPointerOver) {
        hoveredRef.current.userData.onPointerOver();
      }
    }

    if (!hit && hoveredRef.current) {
      if (hoveredRef.current?.userData?.onPointerOut) {
        hoveredRef.current.userData.onPointerOut();
      }
      hoveredRef.current = null;
    }
  });
}
